<template>
  <div class="container">
    <div id="bgimg">
      <div class="caption">
        <span class="border">An Introduction to Aging Population</span><br />
        <span class="border">By Group Pajamas</span>
      </div>
      <div class="icon">
        <p align="center">©2020 University of Southern California</p>
        <br />
        <p align="center">DSCI-554 Project</p>
      </div>
      <div class="countries-list">
        <h3 style="color: #fff">
          14 Classic Countries We picked and <br />Their AgingPopulation Ranking
          Order
        </h3>
        <li>Japan 1</li>
        <li>Italy 2</li>
        <li>Finland 6</li>
        <li>France 14</li>
        <li>Spain 25</li>
        <li>United Kingdom 33</li>
        <li>Canada 36</li>
        <li>United States 47</li>
        <li>Australia 50</li>
        <li>Iceland 54</li>
        <li>Chile 72</li>
        <li>China 74</li>
        <li>Turkey 98</li>
        <li>Mexico 114</li>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Home",
};
</script>

<style scoped>
#bgimg {
  background: url("../assets/image3.jpg");
  /* background-size: 100% 100%; */
  height: 100%;
  position: absolute;
  width: 100%;
  z-index: 0;
  /* filter: blur(5px); */
  /* -webkit-filter: blur(5px); */
  object-fit: cover;
  opacity: 0.7;
  background-repeat: no-repeat;
  background-color: rgba(0, 1, 1, 1);
}

>>> .container {
  position: relative;
}

>>> .caption {
  position: absolute;
  left: 0;
  top: 17%;
  width: 100%;
  text-align: center;
  color: rgba(0, 0, 0, 1);
}

>>> .caption span.border {
  background-color: #000;
  color: #fff;
  padding: 18px;
  font-size: 370%;
  letter-spacing: 10px;
  text-shadow: 2px 1px rgb(138, 134, 134);
}
>>> .icon {
  position: absolute;
  color: #fff;
  letter-spacing: 2px;
  /* font-size: 100%; */
  top: 80%;
  text-align: center;
  width: 100%;
  left: 0;
}
>>> #rank {
  /* background: rgba(0, 0, 0, 1); */
  width: 70%;
  height: 50vh;
  margin-left: 15%;
  margin-top: 5%;
  margin-bottom: 9%;
  color: #fff;
  text-shadow: 1px 1px rgb(94, 92, 92);
}
/* >>> li{
  font-size: 130%;
} */

.countries-list {
  font-size: 80%;
  position: absolute;
  color: #fff;
  letter-spacing: 2px;
  /* font-size: 100%; */
  top: 40%;
  text-align: center;
  /* swidth: 100%; */
  left: 5%;
  background-color: black;
}
</style>